export default "__VITE_PUBLIC_ASSET__3d4f129e__"